module.exports = __webpack_public_path__ + "static/media/Linkedin.1241fda9.svg";